import { DeviceInfoClass } from '@pp/toolkit';

import { mobileCheck } from '../styles/hooks/media';

export const DeviceInfo = new DeviceInfoClass(() => window.matchMedia(mobileCheck).matches);
